export var scales = {
    XL: "xl",
    XXL: "xxl",
    LG: "lg",
    MD: "md",
    SM2: "sm2",
    SM: "sm",
    XS: "xs"
};
